import React from 'react';
import { useTranslation } from 'react-i18next';
import { useIdioma } from '../context/LanguageContext';

// Conmutador de idioma ES/CA — mismo lenguaje visual que el selector de MiPerfil
// (píldoras con borde teal corporativo #077069). Los nombres de idioma van
// SIEMPRE en su propio idioma (autónimos): eso no se traduce.
// `compacto` → versión mini "ES | CA" para cabeceras apretadas.
const OPCIONES = [
  { v: 'es', t: 'Español' },
  { v: 'ca', t: 'Català' },
];

export default function SelectorIdioma({ compacto = false, sutil = false }) {
  // `sutil` (Ann 2026-07-15, menú de llegada): mini y discreto, a juego con los
  // botones vecinos (Salir/¡Opinar!) — nada de bloque verde macizo.
  const { idioma, cambiarIdioma } = useIdioma();
  const { t } = useTranslation();
  return (
    <div
      role="group"
      aria-label={t('idioma.etiqueta')}
      className="ccc-lang"
      style={sutil
        ? { display: 'inline-flex', borderRadius: 10, overflow: 'hidden', border: '1px solid rgba(60,134,150,.35)', background: 'rgba(60,134,150,.12)', height: 28 }
        : { display: 'inline-flex', borderRadius: 10, overflow: 'hidden', border: '1.5px solid #077069', background: '#fff' }}
    >
      {OPCIONES.map((o) => (
        <button
          key={o.v}
          type="button"
          onClick={() => cambiarIdioma(o.v)}
          aria-pressed={idioma === o.v}
          title={o.t}
          style={sutil ? {
            border: 0,
            cursor: 'pointer',
            font: `${idioma === o.v ? 700 : 600} 11px/1 inherit`,
            letterSpacing: '.4px',
            padding: '0 8px',
            background: idioma === o.v ? 'rgba(44,102,117,.9)' : 'transparent',
            color: idioma === o.v ? '#fff' : '#2C6675',
            transition: 'background .15s ease,color .15s ease',
          } : {
            border: 0,
            cursor: 'pointer',
            font: `600 ${compacto ? '11.5px' : '12.5px'}/1 inherit`,
            letterSpacing: '.4px',
            padding: compacto ? '6px 10px' : '8px 14px',
            background: idioma === o.v ? '#077069' : 'transparent',
            color: idioma === o.v ? '#fff' : '#077069',
            transition: 'background .15s ease,color .15s ease',
          }}
        >
          {(compacto || sutil) ? o.v.toUpperCase() : o.t}
        </button>
      ))}
    </div>
  );
}
